import React from 'react'

const Challenge = () => {
  return (
    <section className="lg:py-16 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
          >
            Medical education institutions faced a critical challenge: students were entering clinical rotations
            without adequate hands-on experience with Electronic Health Record systems, leading to costly mistakes
            and extended training periods in real healthcare environments. Traditional paper-based training methods
            couldn't replicate the complexity of modern EHR workflows, and using live production systems posed
            unacceptable risks to patient data privacy and safety.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li >Need for realistic simulation of complex EHR workflows including patient charts, lab orders, prescriptions, and medical histories</li>
            <li >Safe environment for students to practice and make mistakes without risking actual patient data</li>
            <li >Platform for conducting practical examinations with structured faculty feedback mechanisms</li>
            <li >HIPAA and FERPA compliance requirements for educational healthcare data</li>
            <li >Scalability to serve thousands of medical students across multiple institutions simultaneously</li>
            <li >Integration with diverse academic curricula and examination processes</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
